// Public refund portal route (issue #189). No AdminLayout, no RequireAuth —
// the customer reaches /reembolso/:token from an emailed link. Composer
// auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const RefundRequestPublicPage = lazyWithRetry(
  () => import("./pages/RefundRequestPublicPage"),
);

const routes: RouteObject[] = [
  { path: "/reembolso/:token", Component: RefundRequestPublicPage },
];

export default routes;
